import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap'
import { useLocation } from "react-router-dom";
import Moment from 'moment';

export default function PaymentSuccess() {
	let query = new URLSearchParams(useLocation().search);
	const [modalShow, setModalShow] = useState(true);

	const [summary, setSummary] = useState([]);
	const [isGetSummary, setIsGetSummary] = useState(false);


	useEffect(() => {
		if (isGetSummary === false) {
			axios.get('/api/order/' + query.get("paymentID"))
				.then(res => {
					var trans = res.data[0]['trans'];
					setSummary({
						name: trans.insured_name,
						idNo: trans.insured_id_number,
						contactNo: trans.insured_mobile_number,
						emailAdd: trans.insured_email,
						gender: trans.insured_gender,
						dob: Moment(trans.insured_dob).format('YYYY-MM-DD'),
						//applicantType: trans.applicantType,
						// nationality: trans.nationality,
						// address: trans.address,
						insurer: trans.insurer,
						planName: trans.plan,
						// benefit: trans.benefit,
						// premium: trans.premium,
						// serviceTax: trans.sst,
						// stampDuty: trans.stampDuty,
						totalPay: trans.total_payable,
						//promo: trans.promo,
						periodFrom: Moment(trans.inception_date).format('YYYY-MM-DD'),
						periodTo: Moment(trans.expiry_date).format('YYYY-MM-DD'),
						TransactionNo: trans.transaction_number,
						payment_status: trans.payment_status,
						//txn_message: trans.txn_message,
						//policyNoPrepend: trans.policyNoPrepend,
						//policyNo: trans.policyNo
					});
					setIsGetSummary(true);
				})
		}
	}, [query]);

	// useEffect(() => {
	// 	if (isGetSummary === true && summary.length !== 0 && isSentMail === false) {
	// 		axios({
	// 			method: 'post',
	// 			url: '/api/sendsuccessfulCasemail',
	// 			"headers": {
	// 				"content-type": "application/json",
	// 			},
	// 			data: {
	// 				setSuccessCases: summary
	// 			}
	// 		})
	// 			.then(function (response) {
	// 				setIsSentMail(true);
	// 			})
	// 			.catch(function (error) {
	// 				console.log(error);
	// 			})
	// 	}
	// }, [summary]);

	return (
		<div id="product-hero">
			{isGetSummary ?
				<section id="body">
					
					<div className="container">
						<div className="row">
							<div className="col-12">
								<div className="row shadow title position-relative">
									<div className="col-12">
										<h2 className="text-center m-5 text-white font-weight-bold">Payment Successful</h2>
									</div>
								</div>
								<div className="row content">
									<div className="col-md-1"></div>
									<div className="col-12 col-md-12 shadow bg-white rounded">
										<p className="mt-4">Dear, {summary.name}</p>
										<p>Thank you for your payment.</p>
										<p>
											The insurance coverage will only take effect once the approval process has been completed by The Pacific Insurance Berhad.
										</p>
										<p>For any inquiries, please email us at <a href="mailto:instaPol@howdengroup.com" target="_blank">instaPol@howdengroup.com</a></p>

										<div className="card-deck mb-3 text-center">
											<div className="card mb-4 box-shadow">
												<div className="card-header" style={{ backgroundColor: "#c7ddea" }}>
													<h4 className="my-0" style={{ backgroundColor: "#c7ddea" }}>Purchase Summary</h4>
												</div>
												<div className="card-body p-0">
													<table className="table table-bordered table-condensed mb-0">
														<tbody>
															<tr>
																<td style={{ wordWrap: "break-word", width: "50%" }}>Product <br /></td>
																<td style={{ wordWrap: "break-word", width: "50%" }}>Personal Cyber Insurance {summary.product}</td>
															</tr>
															<tr>
																<td style={{ wordWrap: "break-word", width: "50%" }}>Insurer <br /></td>
																<td style={{ wordWrap: "break-word", width: "50%" }}>{summary.insurer}</td>
															</tr>
															<tr>
																<td style={{ wordWrap: "break-word", width: "50%" }}>Transaction No.</td>
																<td style={{ wordWrap: "break-word", width: "50%" }}>{summary.TransactionNo}</td>
															</tr>
															<tr>
																<td style={{ wordWrap: "break-word", width: "50%" }}>Amount</td>
																<td style={{ wordWrap: "break-word", width: "50%" }}>{"RM " + summary.totalPay.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>

										<PromptConfirmation show={modalShow} onHide={() => setModalShow(false)} />

										<div className="row">
											<div className="col-12 mb-5">
												<a href='/landing' className="btn btn-primary mt-4 mb-4" role="button">Back to Home</a>
											</div>
										</div>
										<div className="row mt-4">
											<label className="col-12 col-form-label text-center">You might also be interested in</label>
										</div>

										{/* Big Screen */}
										<div class="row justify-content-center d-none d-lg-block"> 
											<div class="col-12">
												<div id="product-card" class="text-center">
													<div class="row mb-3">
														<a href="https://instapol.my/motor?s=cyber" target="_blank" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
															<div class="product-item2">
																<img src="../images/motor.png" alt="Motor Insurance" height="50" class="mb-3"/>
																<p >Motor Insurance</p>
															</div>                                     
														</a>
															<a href="https://howden-wmotor.instapol.my/landing?s=cyber" target="_blank" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																										<div class="product-item">
																<img src="../images/extended-motor.png" alt="Car Extended Warranty" height="50" class="mb-3"/>
																<p >Car Extended Warranty</p>
															</div>                                        
															</a>
															<a href="https://howden-bike.instapol.my/landing?s=cyber" target="_blank" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																										<div class="product-item">
																<img src="../images/bicycle.png" alt="Bicycle Insurance" height="50" class="mb-3"/>
																<p >Bicycle Insurance</p>
																</div>                                        
																	</a>
																<a href="https://howden-travelplus.instapol.my/landing?s=cyber" target="_blank" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																										<div class="product-item">
																<img src="../images/travel.png" alt="Travel Insurance" height="50" class="mb-3"/>
																<p >Travel Insurance</p>
															</div> 
															</a>
															<a href="https://howden-sme.instapol.my/landing?s=cyber" target="_blank" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																										<div class="product-item">
																<img src="../images/sme.png" alt="SME Medical" height="50" class="mb-3"/>
																<p >SME Medical</p>
															</div>                                        </a>
															<a href="https://howden-house.instapol.my/landing?s=cyber" target="_blank" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																										<div class="product-item">
																<img src="../images/house.svg" alt="HomeProtect" height="50" class="mb-3"/>
																<p >HomeProtect</p>
															</div>                                        </a>
															<a href="https://howden-criticalsafe.instapol.my/landing?s=cyber" target="_blank" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																										<div class="product-item">
																<img src="../images/critical.svg" alt="Critical Illness" height="50" class="mb-3"/>
																<p >Critical Illness</p>
															</div>                                        
															</a>
													</div>
												</div>
											</div>
										</div>

										{/* Small Screen */}
										<div className="d-block d-lg-none">
											<div className="row mb-3 text-center justify-content-around">
												<div className="col-6 col-md-2 mb-3 mb-sm-0">
												<a href="https://instapol.my/motor?s=cyber" target="_blank" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																<div class="product-item2">
																	<img src="../images/motor.png" alt="Motor Insurance" height="50" class="mb-3"/>
																	<p >Motor Insurance</p>
																</div>                                     
															</a>
												</div>
												<div className="col-6 col-md-2 mb-3 mb-sm-0">
												<a href="https://howden-travel.instapol.my/landing?s=cyber" target="_blank" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																											<div class="product-item">
																	<img src="../images/travel.png" alt="Travel Insurance" height="50" class="mb-3"/>
																	<p >Travel Insurance</p>
																</div>                                        </a>
												</div>
												
												<div className="col-6 col-md-2 mb-3 mb-sm-0">
												<a href="https://howden-bike.instapol.my/landing?s=cyber" target="_blank" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																											<div class="product-item">
																	<img src="../images/bicycle.png" alt="Bicycle Insurance" height="50" class="mb-3"/>
																	<p >Bicycle Insurance</p>
																	</div>                                        
																		</a>
												</div>
												
												<div className="col-6 col-md-2 mb-3 mb-sm-0">
												<a href="https://howden-sme.instapol.my/landing?s=cyber" target="_blank" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																											<div class="product-item">
																	<img src="../images/sme.png" alt="SME Medical" height="50" class="mb-3"/>
																	<p >SME Medical</p>
																</div>                                        </a>
												</div>
												<div className="col-6 col-md-2 mb-3 mb-sm-0">
												<a href="https://howden-criticalsafe.instapol.my/landing?s=cyber" target="_blank" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																											<div class="product-item">
																	<img src="../images/critical.svg" alt="Critical Illness" height="50" class="mb-3"/>
																	<p >Critical Illness</p>
																</div>                                        
																</a>
												</div>
												<div className="col-6 col-md-2 mb-3 mb-sm-0">
												<a href="https://howden-house.instapol.my/landing?s=cyber" target="_blank" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																											<div class="product-item">
																	<img src="../images/house.svg" alt="HomeProtect" height="50" class="mb-3"/>
																	<p >HomeProtect</p>
																</div>                                        </a>
												</div>
												
												<div className="col-6 col-md-2 mb-3 mb-sm-0">
												<a href="https://howden-wmotor.instapol.my/landing?s=cyber" target="_blank" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																											<div class="product-item">
																	<img src="../images/extended-motor.png" alt="Car Extended Warranty" height="50" class="mb-3"/>
																	<p >Car Extended Warranty</p>
																</div>                                        
																</a>
												</div>
											</div>
										</div>

										{/* <div id="othProducts" className="row justify-content-around mb-3">
											<div className="col-sm-3">
												<a href="https://instapol.my/travel">
													<img className="img-fluid" src="../images/travel-button.png" loading="lazy" />
												</a>
											</div>
											<div className="col-sm-3">
												<a href="https://instapol.my/motor">
													<img className="img-fluid" src="../images/motor-button.png" loading="lazy" />
												</a>
											</div>
											
										</div> */}
									</div>
									<div className="col-md-1"></div>
								</div>
							</div>
						</div>
					</div>
				</section>
				:
				<div className="text-center mt-5">
					<img src="../images/loading.gif" />
					<br />
					Please wait
				</div>
			}
		</div>
	);
}

function PromptConfirmation(props) {
    return (
        <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Body style={{ padding: 0, position: 'relative' }}>
            <button
                type="button"
                className="close"
                onClick={props.onHide}
                aria-label="Close"
                style={{ position: 'absolute', top: '10px', right: '10px', zIndex: '1' , color: '#ffffff', fontSize: '2.5rem', opacity: '0.7'  }}
            >
                <span aria-hidden="true">&times;</span>
            </button>
            <a href="https://instapol.my/?s=cyber" target="_blank">
                <img
                    src={"../images/roadtax_renew_50_off.jpg"}
                    alt="Full-Sized Image"
                    className="img-fluid modal-image"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
            </a>
        </Modal.Body>
		<Modal.Footer style={{ padding: 0, position: 'relative' }}>
            <div style={{ width: '100%', height: '100%', textAlign: 'center', fontWeight: 'bold', cursor: 'pointer', color: '#9a5cd0'}} onClick={props.onHide}>
                Got It
            </div>
        </Modal.Footer>
    </Modal>
    
    );
}